module.exports = __webpack_public_path__ + "img/evisa-icon1.05283ff5.png";